export function clickOutside(node: HTMLElement, options: { callback: () => void }) {
  const handleClick = (event: MouseEvent) => {
    if (!node.contains(event.target as Node)) {
      options.callback();
    }
  };

  document.addEventListener('click', handleClick, true);

  return {
    destroy() {
      document.removeEventListener('click', handleClick, true);
    },
  };
}
